// extracted by mini-css-extract-plugin
module.exports = {"paper":"popover-button_paper__ol1RM","text":"popover-button_text__Cg4Lx"};